import SampleMasterScreen from "components/modules/sample-module/masters/SampleMasterScreen";
import SampleMasterScreenTabbed from "components/modules/sample-module/masters/SampleMasterScreenTabbed";
import TenantMasterScreen from "components/modules/tenant-management/masters/TenantMasterScreen";
import TenantApplicationAssignmentMasterScreen from "components/modules/tenant-management/masters/TenantApplicationAssignmentMasterScreen";
import ApplicationMasterScreen from "components/modules/platform-admin/masters/ApplicationMasterScreen";
import RoleMasterScreen from "components/modules/platform-admin/masters/RoleMasterScreen";
import TenantUserMasterScreen from "components/modules/user-management/masters/TenantUserMasterScreen";
import EntityMasterScreen from "components/modules/tenant-management/masters/EntityMasterScreen";
import BusinessUnitMasterScreen from "components/modules/tenant-management/masters/BusinessUnitMasterScreen";
import FinancialYearMasterScreen from "components/modules/tenant-management/masters/FinancialYearMasterScreen";

export const COMPONENT_REGISTRY: Record<string, React.ComponentType<any>> = {
  SampleMasterScreenTabbed: SampleMasterScreenTabbed,
  SampleMasterScreen: SampleMasterScreen,
  // Tenant Management
  TenantMasterScreen: TenantMasterScreen,
  TenantApplicationAssignmentMasterScreen: TenantApplicationAssignmentMasterScreen,
  // Organisation master (entities, business units, financial years)
  EntityMasterScreen: EntityMasterScreen,
  BusinessUnitMasterScreen: BusinessUnitMasterScreen,
  FinancialYearMasterScreen: FinancialYearMasterScreen,
  // Platform Admin
  ApplicationMasterScreen: ApplicationMasterScreen,
  RoleMasterScreen: RoleMasterScreen,
  // User Management
  TenantUserMasterScreen: TenantUserMasterScreen,
};